import { createFeatureSelector, createSelector } from '@ngrx/store';
import { selectAll, selectEntities, State } from './lib/kiosk/kiosk.reducer';

export * from './lib/kiosk-api/kiosk-api.actions';
export * from './lib/kiosk-api/kiosk-api.effects';
export * from './lib/kiosk-ws/kiosk-ws.actions';
export * from './lib/kiosk-ws/kiosk-ws.effects';
export * from './lib/kiosk/kiosk.actions';
export * from './lib/kiosk/kiosk.model';
export * from './lib/shared-kiosk-data-access.module';

export const getState = createFeatureSelector<State>('kiosk');

export const getKiosks = createSelector(getState, selectAll);

export const getKioskEntities = createSelector(getState, selectEntities);
